import type { ApiResponse, BaseResponsePagination } from "@/types/models";
import { useAxios } from "@/composables/useAxios";
import type { ProductSearch } from "@/types/product";
export default () => {
  const { callAxios } = useAxios();

  const searchProductApi = async (
    page: number,
    limit: number,
    keyword: string
  ): Promise<ApiResponse<BaseResponsePagination<ProductSearch>> | null> => {
    return await callAxios<ApiResponse<BaseResponsePagination<ProductSearch>>>({
      API: `/api/v1/product/search?keyword=${encodeURIComponent(keyword)}&page=${page}&limit=${limit}`,
      method: "GET"
    });
  };

  return {
    searchProductApi
  };
};
